@if (mode === 'renderer') {
  <div class="products-dc-canvas">
    @if (loadingAssortment) {
      <div class="text-center p-3">
        <div class="spinner-border" role="status">
          <span class="visually-hidden" translate>LOADING</span>
        </div>
        <div class="mt-2" translate>LOADING_ASSORTMENT</div>
      </div>
    }
    @if (carouselAlive && resolvedProductIds && resolvedProductIds.length > 0 && carouselItems && carouselItems.length > 0) {
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let item of carouselItems">
          <ng-template carouselSlide [id]="item.id">
            <div class="dynamic-item-wrapper">
              <ng-container *ngComponentOutlet="item.component; inputs: { data: item.data }"> </ng-container>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    }
    @if ((!resolvedProductIds || resolvedProductIds.length === 0) && edit) {
      <div class="text-center p-4" translate>ADD_PRODUCTS_OR_ASSORTMENT_IN_EDITOR</div>
    }
  </div>
}

@if (mode === 'editor') {
  <div class="row">
    @if (loadingAssortment) {
      <div class="col-12 text-center p-3">
        <div class="spinner-border" role="status">
          <span class="visually-hidden" translate>LOADING</span>
        </div>
        <div class="mt-2" translate>LOADING_ASSORTMENT</div>
      </div>
    }
    <div class="col-12">
      <div class="form-check form-switch mt-2">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="element.fields.useProductsIds"
          id="useProductsIds"
          (ngModelChange)="onSourceChange()"
        />
        <label class="form-check-label" for="useProductsIds" translate>USE_PRODUCTS_IDS</label>
      </div>
    </div>
    @if (element.fields.useProductsIds) {
      <div class="col-12">
        <div class="d-flex flex-column mt-2">
          <label for="typeahead-prevent-manual-entry" translate>Product ID to Add</label>
          <input
            #productElement
            id="typeahead-prevent-manual-entry"
            type="text"
            class="form-control"
            [(ngModel)]="productToAdd"
            [ngbTypeahead]="search"
            [inputFormatter]="inputFormatter"
            [resultFormatter]="resultFormatter"
            (selectItem)="addProduct($event.item)"
          />
        </div>
      </div>
      <div class="col-12" cdkDropList (cdkDropListDropped)="dropProduct($event)">
        @for(productId of element.fields.productsIds; track productId) {
          <div class="product-id-row d-flex align-items-center mt-2" cdkDrag>
            <div class="drag-handle pe-2" cdkDragHandle>
              <i class="fa-solid fa-up-down-left-right"></i>
            </div>
            <div class="flex-grow-1">{{ productId }}</div>
            <i class="fa-solid fa-trash cursor-pointer" (click)="deleteProduct(productId)"></i>

            <ng-template cdkDragPreview>
              <div class="product-id-row d-flex align-items-center p-2 w-100">
                <i class="fa-solid fa-up-down-left-right pe-2"></i>
                <div class="flex-grow-1">{{ productId }}</div>
              </div>
            </ng-template>

            <ng-template cdkDragPlaceholder>
              <div class="product-id-row placeholder w-100"></div>
            </ng-template>
          </div>
        }
      </div>
    } @else {
      <div class="col-12 mt-2">
        <label for="assortment-id-input" translate>ASSORTMENT_ID</label>
        <input
          id="assortment-id-input"
          type="text"
          class="form-control"
          [(ngModel)]="element.fields.assortmentId"
          (blur)="onAssortmentChange()"
          (keyup.enter)="onAssortmentChange()"
        />
      </div>
    }
    <div class="col-12 mt-3">
      <label translate>CAROUSEL_ITEMS</label>
    </div>
    <div class="col-4">
      <lib-gung-number-input
        [gungTranslate]="'MOBILE'"
        [(ngModel)]="element.fields.itemsMobile"
        (ngModelChange)="onItemsChange()"
      ></lib-gung-number-input>
    </div>
    <div class="col-4">
      <lib-gung-number-input
        [gungTranslate]="'TABLET'"
        [(ngModel)]="element.fields.itemsTablet"
        (ngModelChange)="onItemsChange()"
      ></lib-gung-number-input>
    </div>
    <div class="col-4">
      <lib-gung-number-input
        [gungTranslate]="'DESKTOP'"
        [(ngModel)]="element.fields.itemsDesktop"
        (ngModelChange)="onItemsChange()"
      ></lib-gung-number-input>
    </div>
    <div class="col-12 mt-2">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" [(ngModel)]="element.fields.autoplay" id="plc-autoplay" />
        <label class="form-check-label" for="plc-autoplay">{{ 'AUTOPLAY' | translate }}</label>
      </div>
    </div>
    @if (element.fields.autoplay) {
    <div class="col-12">
      <lib-gung-number-input
        [gungTranslate]="'AUTOPLAY_SPEED_SECONDS'"
        [(ngModel)]="element.fields.autoplaySpeed"
      ></lib-gung-number-input>
    </div>
    }
  </div>
}

@if (mode === 'preview') {
  <div class="plc-preview">
    <div class="plc-arrow"><i class="fa-solid fa-chevron-left"></i></div>
    <div class="pl-item">
      <i class="fa-solid fa-image"></i>
      <div class="pl-name">Product</div>
    </div>
    <div class="pl-item">
      <i class="fa-solid fa-image"></i>
      <div class="pl-name">Product</div>
    </div>
    <div class="pl-item">
      <i class="fa-solid fa-image"></i>
      <div class="pl-name">Product</div>
    </div>
    <div class="plc-arrow"><i class="fa-solid fa-chevron-right"></i></div>
  </div>
}
